import { jsx as _jsx } from "react/jsx-runtime";
import { TextAlpha } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COUNTDOWN, ENABLED_DELIVERY_PROMISES } from '../../../constants/DeliveryConstants';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useCountdownTimer } from '../../../hooks/useCountdownTimer';
const DeliveryPromiseMessage = ({ deliveryPromise, textProps }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [deliveryMessage, setDeliveryMessage] = useState('');
    const { countdownMessage } = useCountdownTimer(deliveryPromise.cutoff, deliveryPromise.deliveryMessage);
    const isCountdownTimerMessage = () => {
        var _a;
        return deliveryPromise.hasDeliveryMessage &&
            !!deliveryPromise.cutoff &&
            ((_a = deliveryPromise.deliveryMessage) === null || _a === void 0 ? void 0 : _a.includes(COUNTDOWN)) &&
            ENABLED_DELIVERY_PROMISES.includes(deliveryPromise.name);
    };
    useEffect(() => {
        var _a;
        setDeliveryMessage(deliveryPromise.hasDeliveryMessage
            ? deliveryPromise.deliveryMessage
            : `${t('pdp.size.deliverypromise.txt', {
                deliveryFrom: deliveryPromise.deliveryFrom,
                deliveryTo: deliveryPromise.deliveryTo,
            })} ${t((_a = deliveryPromise.deliveryUnit) !== null && _a !== void 0 ? _a : '')}`);
    }, [deliveryPromise]);
    return (_jsx(TextAlpha, Object.assign({ color: "success" }, textProps, { as: "span", children: isCountdownTimerMessage() ? _jsx("span", { dangerouslySetInnerHTML: { __html: countdownMessage } }) : deliveryMessage })));
};
export default DeliveryPromiseMessage;
